module.exports = __webpack_public_path__ + "static/media/November2021Newsletter.84d8de04.pdf";